import React, { useCallback, useState } from "react";
import "../styles/UnsubscribePopup.css";
import "../styles/unSubSuccessModal.css";
import "../styles/ConfirmUnsubModal.css";

import jazzcashLogo from "../Assets/imgs/landingJazzCash/jazzcashlogo.webp";
import arrowBack from "../Assets/imgs/arrow back.webp";
import warningIcon from "../Assets/imgs/warning-icon.webp";
import successIcon from "../Assets/imgs/success-icon.webp";
import { Spinner } from "react-bootstrap";

import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { fetchApiPostRecaptcha } from "../utils/FetchApi";
import { ApiName } from "../Constant/ApiName";
type PopupProps = {
  setUnsubscribePopup: React.Dispatch<React.SetStateAction<boolean>>;
};

const GuestUnsubscribeModal = ({ setUnsubscribePopup }: PopupProps) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [unsubSuccessPopup, setUnsubSuccessPopup] = useState(false);
  const [confirmUnsubPopup, setConfirmUnsubPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [msisdn, setMsisdn] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);

  const onMsisdnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessage("");
    const userInput = e.target.value;
    if (
      !userInput ||
      (userInput.length <= 10 && /^3\d{0,9}$/.test(userInput))
    ) {
      setErrorMessage("");
      setMsisdn(userInput);
    }
  };
  const handleUnSubscribe = () => {
    if (msisdn.length !== 10) {
      setErrorMessage("Please enter a valid 10-digit Jazz Cash number.");
      return;
    }
    setConfirmUnsubPopup(true);
  };
  const handleConfirmUnSub = async () => {
    if (!executeRecaptcha) {
      setErrorMessage("Verification is still loading. Please try again.");
      return;
    }
    try {
      setConfirmLoading(true);
      setErrorMessage("");
      const recaptchaToken = await executeRecaptcha("guest_unsubscribe");
      const response = await fetchApiPostRecaptcha(
        ApiName.guestUnSubscribe + msisdn,
        recaptchaToken,
      );
      if (response.status === 200 && response.results?.code == "0") {
        setConfirmUnsubPopup(false);
        setUnsubSuccessPopup(true);
      } else if (response.status === 200 && response.results?.code == "-1") {
        setErrorMessage("You do not have any active subscriptions.");
      } else {
        setErrorMessage("Unable to Unsubscribe, Please try again.");
      }
    } catch (error) {
      console.log(error);
      setErrorMessage("Something went wrong, Please try again.");
    } finally {
      setConfirmLoading(false);
    }
  };
  return (
    <>
      {!confirmUnsubPopup && (
        <UnsubscribeModal
          setUnsubscribePopup={setUnsubscribePopup}
          msisdn={msisdn}
          errorMessage={errorMessage}
          handleUnSubscribe={handleUnSubscribe}
          onMsisdnChange={onMsisdnChange}
        />
      )}

      {confirmUnsubPopup && (
        <GuestUnSubConfirmModal
          setConfirmUnsubPopup={setConfirmUnsubPopup}
          handleConfirmUnSub={handleConfirmUnSub}
          loading={confirmLoading}
          errorMessage={errorMessage}
        />
      )}

      {unsubSuccessPopup && (
        <GuestUnSubSuccessModal setUnsubSuccessPopup={setUnsubSuccessPopup} />
      )}
    </>
  );
};

export default GuestUnsubscribeModal;

type UnsubscribeModalProps = {
  setUnsubscribePopup: React.Dispatch<React.SetStateAction<boolean>>;
  msisdn: string;
  onMsisdnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage: string;
  handleUnSubscribe: () => void;
};
const UnsubscribeModal = (props: UnsubscribeModalProps) => {
  return (
    <div
      className="popup-overlay"
      onClick={() => {
        props.setUnsubscribePopup(false);
      }}
    >
      <div className="unsubscribe-popup">
        <div className="arrow-heading">
          <img
            src={arrowBack}
            alt="arrow"
            className="back-btn"
            onClick={() => props.setUnsubscribePopup(false)}
          />
          <h2>Unsubscribe</h2>
        </div>

        <label>Enter your Jazzcash number</label>
        <div className="input-box">
          <div className="input-prefix">
            <img src={jazzcashLogo} alt="JazzCash" />
          </div>
          <input
            type="text"
            placeholder="308 - 1234567"
            value={props.msisdn}
            onChange={props.onMsisdnChange}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        <p className="gu-protected">Protected by reCAPTCHA</p>
        <p
          style={{
            color: "red",
            textAlign: "center",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {props.errorMessage}
        </p>
        <button
          className="unsubscribe-btn"
          onClick={(e) => {
            e.stopPropagation();
            props.handleUnSubscribe();
          }}
        >
          Unsubscribe
        </button>
      </div>
    </div>
  );
};

type GuestUnSubConfirmModalProps = {
  setConfirmUnsubPopup: React.Dispatch<React.SetStateAction<boolean>>;
  handleConfirmUnSub: () => Promise<void>;
  loading: boolean;
  errorMessage: string;
};
const GuestUnSubConfirmModal = (props: GuestUnSubConfirmModalProps) => {
  return (
    <div
      className="popup-overlay"
      onClick={() => !props.loading && props.setConfirmUnsubPopup(false)}
    >
      <div className="confirm-popup">
        <div className="warning-icon">
          <img src={warningIcon} alt="warning icon" />
        </div>

        <h2>Unsubscribe</h2>

        <p>Are you sure you want to unsubscribe?</p>

        {props.errorMessage && (
          <p style={{ color: "red", textAlign: "center" }}>
            {props.errorMessage}
          </p>
        )}

        <div className="popup-buttons">
          <button
            className="unsubscribe-Btn"
            disabled={props.loading}
            onClick={(e) => {
              e.stopPropagation();
              props.handleConfirmUnSub();
            }}
          >
            {props.loading ? (
              <Spinner
                animation="border"
                role="status"
                size="sm"
                style={{ color: "inherit" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              "Unsubscribe"
            )}
          </button>

          <button
            className="cancel-btn"
            disabled={props.loading}
            onClick={(e) => {
              e.stopPropagation();
              props.setConfirmUnsubPopup(false);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

type GuestUnSubSuccessModalProps = {
  setUnsubSuccessPopup: React.Dispatch<React.SetStateAction<boolean>>;
};
const GuestUnSubSuccessModal = (props: GuestUnSubSuccessModalProps) => {
  return (
    <div
      className="popup-overlay"
      onClick={() => props.setUnsubSuccessPopup(false)}
    >
      <div className="success-popup">
        <img src={successIcon} alt="success" className="success-img" />
        <h2>Congratulations</h2>
        <p>You've successfully unsubscribe.</p>
        <button className="continue-btn">Continue</button>
      </div>
    </div>
  );
};
